module.exports = __webpack_public_path__ + "static/img/icono_comenzar.81ff079d.svg";